module.exports = __webpack_public_path__ + "images/category_lp/watch/store_images/1_897b3205a8c49cdbd8213b198f621b35.png";